export const downloadRegisteredRcsTemplatesMutation = (builder) => ({
  downloadRegisteredRcsTemplates: builder.mutation({
    query: ({ status = "", userId = "", search = "", templateType = "", loggedin_user_id, user_type_id, }) => {
      const token = JSON.parse(localStorage.getItem("TOKEN"))?.token || "";
      return {
        url: "/download_registered_rcs_templates",
        method: "GET",
        params: {
          status,
          userId,
          search,
          templateType,
          loggedin_user_id, user_type_id,
          associatedEnterpriseId: token.associated_enterprise_id,
          userTypeId: token.user_type_id,
        },
        headers: {
          "Content-Type": "text/csv",
        },
        responseHandler: (response) => response.blob(),
      };
    },
  }),
});
